import { P } from '../../components/ui'

export default function PSFAPortal() {
    return (
        <>
            <h1 className='govuk-heading-xl'>GRID Sign-in</h1>

            <P>GRID Sign-in is how Government departments and other organisations can access GRID’s online services</P>
            <P>To access your GRIS online services, you’ll either need:</P>
            <ul>
                <li className='li-no-padding'>
                    <P>
                        <b>an existing GRID Sign-in account.</b> This will ne the email address and password you created
                        when you first accessed GRID Sign-in.
                    </P>
                </li>
                <li className='li-no-padding'>
                    <P>
                        <b>to create a DfE Sign-in account.</b> If you haven’t used GRID Sign-in before you need to
                        create a GRID Sign-in account.
                    </P>
                </li>
            </ul>
        </>
    )
}
